import { ChangeEvent, FC } from 'react';

import { Cell, CellText, Checkbox, FormLabel, Input, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AdfoxPlacement } from 'components/Admin/AdfoxInfo/adfoxInfoModel';
import { FullScreenStyleFields } from 'components/Admin/AdfoxInfo/PromoFields/FullScreenStyleFields/FullScreenStyleFields';
import { OrdFields } from 'components/Admin/AdfoxInfo/PromoFields/OrdFields/OrdFields';

import { updateAdfoxInfoForm } from 'store/models/adfoxInfo';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    ctaLabel: 'admin.adfoxInfo.field.ctaLabel',
    ctaLabelPlaceholder: 'admin.adfoxInfo.ctaLabel.placeholder',
    ctaExternalBrowser: 'admin.adfoxInfo.ctaExternalBrowser',
    advertising: 'admin.adfoxInfo.advertising',
};

export const PromoFields: FC = () => {
    const form = useSelector((state) => state.adfoxInfo);

    const trls = useTrls();
    const dispatch = useDispatch();

    return (
        <>
            <VSpacingContainer default={12}>
                <FormLabel>{trls(TrlKeys.ctaLabel)}</FormLabel>
                <Input
                    size="medium"
                    value={form.ctaLabel}
                    placeholder={trls(TrlKeys.ctaLabelPlaceholder)}
                    onChange={(ctaLabel) => dispatch(updateAdfoxInfoForm({ ctaLabel }))}
                    data-qa="adfox-info-cta-label"
                />
            </VSpacingContainer>
            <Cell
                left={
                    <Checkbox
                        checked={form.openCtaInExternalBrowser}
                        onChange={(event: ChangeEvent<HTMLInputElement>) =>
                            dispatch(updateAdfoxInfoForm({ openCtaInExternalBrowser: event.target.checked }))
                        }
                        data-qa="adfox-info-cta-external-browser"
                    />
                }
            >
                <CellText>{trls(TrlKeys.ctaExternalBrowser)}</CellText>
            </Cell>
            {form.placement === AdfoxPlacement.FullScreen && <FullScreenStyleFields />}
            <Cell
                left={
                    <Checkbox
                        checked={form.isAdvertising}
                        onChange={(event: ChangeEvent<HTMLInputElement>) =>
                            dispatch(updateAdfoxInfoForm({ isAdvertising: event.target.checked }))
                        }
                        data-qa="adfox-info-advertising"
                    />
                }
            >
                <CellText>{trls(TrlKeys.advertising)}</CellText>
            </Cell>
            {form.isAdvertising && <OrdFields />}
        </>
    );
};
